import React,{useState} from 'react'
import video1 from '../img/video1.mp4'
import HomeEvents from './HomeEvents';
import HomeWorkshops from './HomeWorkshops';
import CountUp from 'react-countup';
import Special from './Special';
import { useNavigate } from 'react-router-dom';
import { IoCloseOutline,IoPlaySharp } from "react-icons/io5";

const Home = () => {
 
const [showvideo,setShowVideo]=useState(false);
const history=useNavigate();
const openGallary=()=>{
    window.scrollTo(0,0);
    history('/gallary')

}

    return (
        <>
   <div className="home">
       <div className="home__wrapper"></div>
       <div className="home__top">
           <h2>You Can Learn Everything</h2>
           <h1>Eclatecs <span id='span1'>2</span><span id='span2'>K</span><span id='span3'>2</span><span id='span4'>2</span></h1>
           <h2>Join the event today !</h2>
           <div className="promo">
               <i onClick={()=>setShowVideo(true)}><IoPlaySharp /></i>
               <h4>play promo</h4>
           </div>
          {showvideo &&  <div className="video">
              <div className="video-inner">
               <video style={{position:'absolute',top:'-10%',left:'-10%',zIndex:'1000000',}} width={'1100px'} height={'auto'} controls autoPlay>
                   <source src={video1} type='video/mp4' />
               </video>
              <i onClick={()=>setShowVideo(false)}><IoCloseOutline /></i>
              </div>
           </div>}

       </div>
      {/* end of top */}
      {/* <i><CountUp end={500} duration={3}/></i> */}
      <div className="home__content">
          <div className="home__events">
                <HomeEvents />
              
          </div>
          <div className="home__workshops">
                <HomeWorkshops />
          </div>
          <Special />
          <div className="home__memories" onClick={openGallary}>
              <h2>Do visit the memories section</h2>
          </div>
      </div>
   </div>
        </>
    )
}

export default Home
